import { Field } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";

const TableSelectField = ({
  element,
  option,
  error,
  id,
  tdkeys,
  rowkeys,
  tableName,
  name,
  errorBorder,
  values,
  childOpt,
  pageId,
  schemaItem,
  disabled,
  tableChildOpts,
}) => {
  if (element?.prefix === "SLI") {
    // per-row, per-pair map takes precedence; fall back to legacy global childOpt
    const rowOptKey = `${tdkeys}_${schemaItem}`;
    if (tableChildOpts && rowOptKey in tableChildOpts) {
      option = tableChildOpts[rowOptKey];
    } else if (
      childOpt &&
      childOpt.childPageId === pageId &&
      childOpt.childItemId === schemaItem
    ) {
      option = childOpt.optionsData;
    }
    return (
      <div className="wrapper">
        <div className="form-field">
          <Field
            as="select"
            className={`tableInput ${errorBorder}`}
            id={id + tdkeys + 1}
            rowkeys={tdkeys}
            tdkeys={rowkeys}
            name={`${tableName}[${tdkeys}].${name}`}
            data-testid="TableSelectField"
            value={values?.[tableName]?.[tdkeys]?.[name] || ""}
            disabled={disabled}
          >
            <option value=""></option>
            {option.map((i, index) => (
              <option key={index} value={i.value}>
                {i.label}
              </option>
            ))}
          </Field>
          {error?.[name] && (
            <span className="icon">
              <Tooltip title={error[name]}>
                <WarningIcon sx={{ color: pink[500] }} />
              </Tooltip>
            </span>
          )}
        </div>
      </div>
    );
  }
  return null;
};

export default TableSelectField;
